import React, { PropsWithChildren } from 'react'
import clsx from 'clsx'
import { SideNav as SideNavStyles } from '@airbus/elements/elements'
import { createUseStyles } from '../../lib/styling'
import { CommonProps } from '../helperTypes'

const useStyles = createUseStyles(SideNavStyles, 'sidenav')

const SideNavSection = ({ children, className, ...rest }: PropsWithChildren<CommonProps>) => {
  const classes = useStyles()

  return (
    <ul {...rest} className={clsx(className, classes.section)} aria-hidden='false'>
      {children}
    </ul>
  )
}

export default SideNavSection
